import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Body from "src/components/common/Body";
import Box from "src/components/common/Box";
import Button from "src/components/common/Button";
import SearchInput from "src/components/common/SearchInput";
import List from "src/components/common/List";
import styled from "styled-components";
import { useAddGroupNameMutation, useSelectStoreQuery } from "src/api/userAPI";
import setQueryString, { getPathValue } from "src/utils/queryStringUtil";
import { useAppDispatch, useAppSelector } from "src/store/actions/action";
import { setSearchContents } from "src/store/reducers/asReduce";
import Chip from "src/components/common/Chip";
import Accodion from "src/assets/images/accodion.svg";
import AccodionActive from "src/assets/images/accodionActive.svg";
import cn from "classnames";
import setQueryStringVer from "src/utils/reuseQueryString";
import PaginationCommon from "src/components/common/PaginationCommon";
import { isEmpty } from "lodash";
import BottomModal, { RefProps } from "src/components/common/BottomModal";
import SearchSortItem from "src/components/filter/SearchSortItem";
import SearchStoreFilterItemV2 from "src/components/filter/SearchStoreFilterItemV2";
import SVG from "src/utils/SVG";
import reuseQueryStringV2 from "src/utils/reuseQueryStringV2";

// 매장 필터 초기화
const initStore: StoreFilter[] = [
  { storeType: "백화점", checked: false },
  { storeType: "대리점", checked: false },
  { storeType: "직영점", checked: false },
  { storeType: "면세점", checked: false },
];
const initFilter: Filter = { sortSearchString: "최신순", newStoreSearchString: "", typeSearchArray: [], contentsSearchString: "" };

/**
 *  그룹을 추가만 하는 곳 여기서는 insert를 하지 않고 search하여 데이터를 groupEdit.tsx로 보낸다.
 * @returns
 */
function groupAdd() {
  const navigate = useNavigate();
  const [isActive, setActive] = useState(true);
  const selectBoxRef = React.useRef<HTMLDivElement>(null);
  const chipBoxRef = React.useRef<HTMLDivElement>(null);
  
  // 필터 상태
  const [sortFilter, setSortFilter] = useState<Filter>(initFilter);
  const [strSortFilter, setStrSortFilter] = useState(reuseQueryStringV2(sortFilter));
  const [newStoreToggle, setNewStoreToggle] = useState<boolean>(false);
  const [storeFilterList, setStoreFilterList] = useState<StoreFilter[]>(initStore);
  const [applyStoreFilterList, setApplyStoreFilterList] = useState<StoreFilter[]>(initStore);
  
  // 모달 참조
  const filterModalRef = useRef<RefProps>(null);
  const sortModalRef = useRef<RefProps>(null);
  const filterListRef = useRef<HTMLDivElement>(null);
  
  // 정렬 상태
  const [sortIdx, setSordIdx] = useState<number>(0);
  const [initVisible, setInitVisible] = useState<boolean>(false);
  
  // 전체 선택 상태
  const [selectAll, setSelectAll] = useState<boolean>(false);

  useEffect(() => {
    if (selectBoxRef.current === null || chipBoxRef.current === null) {
      return;
    }
    selectBoxRef.current.style.height = `${60 + chipBoxRef.current.clientHeight}px`;
  }, []);

  const toggleSelectedBox = () => {
    if (selectBoxRef.current === null || chipBoxRef.current === null) {
      return;
    }
    if (isActive) {
      selectBoxRef.current.style.height = "88px";
      chipBoxRef.current.scrollTop = 0;
    } else {
      selectBoxRef.current.style.height = `${60 + chipBoxRef.current.clientHeight}px`;
    }
    setActive(!isActive);
  };
  // ================================== 퍼블리싱 영역 ==================================

  // 라이브러리 선언 영역
  const group_index: any = getPathValue();
  const navigateState = useLocation();

  // 값 세팅 영역
  const [inputs, setInputs] = useState({
    searchStoreName: "",
    totalPages: 0,
  });
  const { searchStoreName, totalPages } = inputs;

  const [state, setState] = useState({
    apiSkip: true,
    rerender: true,
    filterData: "",
  });
  const { apiSkip, rerender, filterData } = state;

  const [storeList, setStoreList] = useState({
    sendData: [] as string[],
    viewData: [] as string[],
    categoryData: [] as string[],
    phoneData: [] as string[],
  });

  const { sendData, viewData, categoryData, phoneData } = storeList;

  const [page, setPage] = useState(1);
  
  // 필터 목록 스크롤을 위한 이펙트
  useEffect(() => {
    filterListRef.current && filterListRef.current.scrollTo({ behavior: "smooth", left: filterListRef.current.scrollLeft + filterListRef.current.scrollWidth });
  }, [applyStoreFilterList]);
  
  // 필터 업데이트를 위한 이펙트
  useEffect(() => {
    setStrSortFilter(reuseQueryStringV2(sortFilter));
  }, [sortFilter]);
  
  useEffect(() => {
    const tempTypeSearchArray: string[] = [];
    applyStoreFilterList.forEach((value) => value.checked && tempTypeSearchArray.push(value.storeType));
    setSortFilter({ ...sortFilter, typeSearchArray: tempTypeSearchArray });
  }, [applyStoreFilterList]);

  const [currentPage, setCurrentPage] = useState<number | any>();

  const [navigateStateDate, setNavigateStateData] = useState<any>(navigateState.state);

  const [queryString, setQueryString] = useState({
    pageSearchNumber: 1,
    contentsSearchString: "",
  });

  // API 호출을 위한 통합 쿼리 스트링
  const combinedQueryString = useMemo(() => {
    if (!strSortFilter) return filterData;
    
    // 기존 시스템의 페이지네이션이 있다면 새로운 필터 시스템과 결합
    if (filterData && filterData.includes('page=')) {
      const pageParam = filterData.match(/[?&]page=\d+/)?.[0] || '';
      return strSortFilter + pageParam;
    }
    
    return strSortFilter;
  }, [strSortFilter, filterData]);

  // API 영역
  // 검색영역 store - 통합 쿼리 스트링 사용
  const storeListAPI = useSelectStoreQuery(combinedQueryString, { skip: !combinedQueryString });

  // 생명 주기 영역

  useEffect(() => {
    setCurrentPage(1);
  }, []);

  useEffect(() => {
    if (storeListAPI.isSuccess) {
      setInputs({
        ...inputs,
        totalPages: storeListAPI.data.meta.totalPages,
      });
      setCurrentPage(storeListAPI.data.meta.currentPage);
    }
  }, [storeListAPI]);

  useEffect(() => {
    const filter = setQueryStringVer(queryString);
    setState({
      ...state,
      filterData: filter,
      apiSkip: false,
    });
  }, [queryString]);

  // Event 영역
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;

    setInputs({
      ...inputs,
      searchStoreName: value,
    });
  };

  const onKeyPress = (e: any) => {
    if (e.key === "Enter") {
      searchStore(e);
    }
  };

  const searchStore = (e: any) => {
    const contents = e.currentTarget.parentElement?.childNodes[0].value;
    setInputs({
      ...inputs,
      searchStoreName: contents,
    });
    // 검색 내용으로 sortFilter 업데이트
    setSortFilter({
      ...sortFilter,
      contentsSearchString: contents || "",
    });
    // 페이지네이션 호환성을 위해 기존 queryString도 업데이트
    setQueryString({
      ...queryString,
      contentsSearchString: contents!,
      pageSearchNumber: 1,
    });
  };

  // 자식으로 넘겨주는 함수 영역
  const parentRender = () => {
    setState({
      ...state,
      rerender: !rerender,
    });
  };

  const objectChange = (currentPage: number) => {
    // 페이지네이션을 위한 기존 queryString 업데이트 (페이지네이션 API에 여전히 필요)
    setQueryString({
      ...queryString,
      pageSearchNumber: currentPage,
    });
    setPage(currentPage);
  };

  const groupInsertBtn = () => {
    //
  };

  // 확인 버튼 클릭
  const confirmBtn = () => {
    const stateData: Array<any> = [];
    for (let i = 0; i < sendData.length; i++) {
      const settingForm = {
        name: viewData[i],
        store_type_name: categoryData[i],
        phone_number: phoneData[i],
        user_id: sendData[i],
      };
      stateData.push(settingForm);
    }
    if (navigateStateDate !== null) {
      // 그룹 수정
      navigate("/group-edit/" + group_index, { state: { send: stateData, groupName: navigateStateDate.groupName } });
    } else {
      // 그룹 신규 등록
      navigate("/group-edit", { state: { send: stateData } });
    }
  };

  const selectStoreDelete = (v: string, idx: number) => {
    viewData.splice(idx, 1);
    sendData.splice(idx, 1);
    categoryData.splice(idx, 1);
    phoneData.splice(idx, 1);
    setState({
      ...state,
      rerender: !rerender,
    });
  };

  const deleteSearchContents = () => {
    setInputs({
      ...inputs,
      searchStoreName: "",
    });
    // 검색 내용을 지우기 위해 sortFilter 업데이트
    setSortFilter({ 
      ...sortFilter, 
      contentsSearchString: "" 
    });
    // 페이지네이션 호환성을 위해 기존 queryString도 업데이트
    setQueryString({
      ...queryString,
      pageSearchNumber: 1,
      contentsSearchString: "",
    });
  };
  
  // 필터 모달 함수들
  const openFilterModal = useCallback(() => {
    if (filterModalRef.current) filterModalRef.current.modalOpen();
  }, []);
  
  const openSortModal = useCallback(() => {
    if (sortModalRef.current) sortModalRef.current.modalOpen();
  }, []);
  
  const sortBtn = (e: any) => {
    const sortName = e.target.textContent;
    sortName && setSortFilter({ ...sortFilter, sortSearchString: sortName });
    if (sortModalRef.current) sortModalRef.current.modalClose();
  };
  
  const childrenSortIdxFunc = (idx: number) => {
    setSordIdx(idx);
  };
  
  const newStoreBtn = () => {
    if (newStoreToggle) {
      setSortFilter({ ...sortFilter, newStoreSearchString: "" });
    } else {
      setSortFilter({ ...sortFilter, newStoreSearchString: "T" });
    }
    setNewStoreToggle(!newStoreToggle);
  };
  
  const setInitFunc = (propsSelectedFliterCheck: boolean) => {
    setInitVisible(propsSelectedFliterCheck);
  };
  
  const closeBtn = () => {
    setStoreFilterList(applyStoreFilterList);
  };
  
  const confirmFilterBtn = () => {
    setApplyStoreFilterList(storeFilterList);
    filterModalRef.current && filterModalRef.current.modalClose();
  };
  
  const resetButton = () => {
    setStoreFilterList(initStore);
  };
  
  function changeChecked(value: StoreFilter) {
    const temp: StoreFilter[] = storeFilterList.map((filter) =>
      filter.storeType === value.storeType ? { ...filter, checked: !filter.checked } : { ...filter, checked: filter.checked },
    );
    setStoreFilterList(temp);
  }
  
  function deleteFilter(value: StoreFilter) {
    const temp: StoreFilter[] = applyStoreFilterList.map((filter) => (filter.storeType === value.storeType ? { ...filter, checked: false } : filter));
    setApplyStoreFilterList(temp);
    setStoreFilterList(temp);
  }
  
  // 전체 선택 기능 - 새 항목만 추가하고 기존 항목은 지우지 않음
  const toggleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      // 현재 목록에서 아직 선택되지 않은 새 매장만 추가
      if (storeListAPI.isSuccess && storeListAPI.data.data.length > 0) {
        const currentStores = storeListAPI.data.data;
        const newStoresToAdd = currentStores.filter((store: any) => !sendData.includes(store.user_id));
        
        if (newStoresToAdd.length > 0) {
          const newSendData = newStoresToAdd.map((store: any) => store.user_id);
          const newViewData = newStoresToAdd.map((store: any) => store.name);
          const newCategoryData = newStoresToAdd.map((store: any) => store.store_type_name);
          const newPhoneData = newStoresToAdd.map((store: any) => store.phone_number);
          
          setStoreList({
            sendData: [...sendData, ...newSendData],
            viewData: [...viewData, ...newViewData],
            categoryData: [...categoryData, ...newCategoryData],
            phoneData: [...phoneData, ...newPhoneData],
          });
        }
      }
    } else {
      // 현재 보이는 목록의 매장만 선택 해제
      if (storeListAPI.isSuccess && storeListAPI.data.data.length > 0) {
        const currentStoreIds = storeListAPI.data.data.map((store: any) => store.user_id);
        
        // 현재 보이는 매장은 제외하고 다른 매장은 유지
        const filteredData = sendData.map((storeId: string, index: number) => {
          if (currentStoreIds.includes(storeId)) {
            return null; // 제거 표시
          }
          return {
            sendData: storeId,
            viewData: viewData[index],
            categoryData: categoryData[index],
            phoneData: phoneData[index],
          };
        }).filter(item => item !== null);
        
        setStoreList({
          sendData: filteredData.map(item => item!.sendData),
          viewData: filteredData.map(item => item!.viewData),
          categoryData: filteredData.map(item => item!.categoryData),
          phoneData: filteredData.map(item => item!.phoneData),
        });
      }
    }
    setState({
      ...state,
      rerender: !rerender,
    });
  };
  
  // 현재 보이는 목록에서 선택된 개수 계산
  const getSelectedCountFromCurrentList = () => {
    if (!storeListAPI.isSuccess || !storeListAPI.data.data.length) return 0;
    const currentStoreIds = storeListAPI.data.data.map((store: any) => store.user_id);
    return sendData.filter((storeId: string) => currentStoreIds.includes(storeId)).length;
  };
  
  // 매장 목록이나 필터가 변경될 때 전체 선택 상태 업데이트
  useEffect(() => {
    if (storeListAPI.isSuccess && storeListAPI.data.data.length > 0) {
      const currentStoreIds = storeListAPI.data.data.map((store: any) => store.user_id);
      const selectedFromCurrentList = sendData.filter((storeId: string) => currentStoreIds.includes(storeId));
      const allSelected = currentStoreIds.length > 0 && currentStoreIds.every((id: string) => selectedFromCurrentList.includes(id));
      setSelectAll(allSelected);
    } else {
      setSelectAll(false);
    }
  }, [storeListAPI.data, sendData, sortFilter, applyStoreFilterList, newStoreToggle]);
  
  // 개별 매장 선택 처리
  const handleStoreSelection = (e: React.ChangeEvent<HTMLInputElement>, store: any) => {
    const isChecked = e.target.checked;
    const storeId = store.user_id;
    
    if (isChecked) {
      // 선택에 매장 추가
      setStoreList({
        sendData: [...sendData, storeId],
        viewData: [...viewData, store.name],
        categoryData: [...categoryData, store.store_type_name],
        phoneData: [...phoneData, store.phone_number],
      });
    } else {
      // 선택에서 매장 제거
      const storeIndex = sendData.indexOf(storeId);
      if (storeIndex > -1) {
        const newSendData = [...sendData];
        const newViewData = [...viewData];
        const newCategoryData = [...categoryData];
        const newPhoneData = [...phoneData];
        
        newSendData.splice(storeIndex, 1);
        newViewData.splice(storeIndex, 1);
        newCategoryData.splice(storeIndex, 1);
        newPhoneData.splice(storeIndex, 1);
        
        setStoreList({
          sendData: newSendData,
          viewData: newViewData,
          categoryData: newCategoryData,
          phoneData: newPhoneData,
        });
      }
    }
    
    setState({
      ...state,
      rerender: !rerender,
    });
  };

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => navigate(-1)}>
            대상선택
          </Button>
        </div>
        <div className="btn-box">
          <Button variant="text" onClick={confirmBtn}>
            확인
          </Button>
        </div>
      </header>

      <Body>
        <FixedBox>
          {viewData.length > 0 && (
            <SelectedBox className={cn({ active: isActive })} ref={selectBoxRef}>
              <div className="title-box" onClick={toggleSelectedBox}>
                <p>선택 {viewData?.length}</p>
              </div>
              <div className="chip-box" ref={chipBoxRef}>
                {viewData?.map((v, idx) => {
                  return (
                    <Chip variant="contained" deleted={true} key={idx} onDelete={() => selectStoreDelete(v, idx)}>
                      {v}
                    </Chip>
                  );
                })}
              </div>
            </SelectedBox>
          )}

          <Box bg="#fff" pd="20px 15px">
            {/* 그룹추가일경우 노출 */}
            <SearchInput
              type="text"
              id=""
              placeholder="매장 또는 업체명을 입력해주세요."
              defaultValue={searchStoreName}
              onChange={(e) => onChange(e)}
              onClick={(e) => searchStore(e)}
              onKeyPress={(e) => {
                onKeyPress(e);
              }}
              deleteSearchContentFunc={deleteSearchContents}
            />
          </Box>
          
          {/* 필터 버튼 세트 */}
          <FilterBtnSet ref={filterListRef}>
            <Button variant="contained" br="round" color="secondary" size="medium" onClick={openFilterModal}>
              <SVG name="filter" width={16} height={16} viewBox="0 0 16 16" />
              필터
            </Button>
            <Button variant="contained" br="round" color="secondary" size="medium" onClick={openSortModal}>
              <SVG name="sort" width={14.637} height={16.348} viewBox="0 0 14.637 16.348" />
              {sortFilter.sortSearchString}
            </Button>
            <Button className="only-new" variant="contained" br="round" color={newStoreToggle ? "active" : "secondary"} size="medium" onClick={newStoreBtn}>
              {newStoreToggle ? (
                <SVG name="toggleActive" width={16} height={16} viewBox="0 0 16 16" />
              ) : (
                <SVG name="toggle" width={16} height={16} viewBox="0 0 16 16" />
              )}
              신규매장만
            </Button>
            {applyStoreFilterList.map((value, index) => {
              return (
                value.checked && (
                  <Chip variant="contained" deleted={true} key={index} onDelete={() => deleteFilter(value)}>
                    {value.storeType}
                  </Chip>
                )
              );
            })}
          </FilterBtnSet>
        </FixedBox>

        {/* 개수 표시 및 전체 선택 섹션 */}
        {storeListAPI.isSuccess && storeListAPI.data.data.length > 0 && (
          <CountingSection>
            <div className="all-check">
              <div>
                {getSelectedCountFromCurrentList()}/{storeListAPI.data.data.length}
              </div>
              <div>
                <label className="all-label" htmlFor="allCheck">
                  전체선택
                  {selectAll ? (
                    <SVG name="roundCheckboxActive" width={24} height={24} viewBox="0 0 24 24" />
                  ) : (
                    <SVG name="roundCheckbox" width={24} height={24} viewBox="0 0 24 24" />
                  )}
                  <input type="checkbox" id="allCheck" checked={selectAll} onChange={toggleSelectAll} />
                </label>
              </div>
            </div>
          </CountingSection>
        )}

        {/* 간단한 표시로 매장 목록 */}
        {storeListAPI.isSuccess && storeListAPI.data.data.length > 0 ? (
          <SimpleStoreList>
            {storeListAPI.data.data.map((store: any, idx: number) => {
              const isSelected = sendData.includes(store.user_id);
              return (
                <li key={idx}>
                  <label className="item-label" htmlFor={store.user_id}>
                    <span className="tag">{store.store_type_name}</span>
                    <span className="title">
                      {store.name}
                      {store.new_yn === "Y" && <SVG name="new" width={10} height={16} viewBox="0 0 10 16" />}
                      <span className="userId">{store.user_id}</span>
                    </span>
                    {isSelected ? (
                      <SVG name="roundCheckboxActive" width={24} height={24} viewBox="0 0 24 24" />
                    ) : (
                      <SVG name="roundCheckbox" width={24} height={24} viewBox="0 0 24 24" />
                    )}
                    <input
                      type="checkbox"
                      id={store.user_id}
                      checked={isSelected}
                      onChange={(e) => handleStoreSelection(e, store)}
                    />
                  </label>
                </li>
              );
            })}
          </SimpleStoreList>
        ) : (
          <NoResult>리스트 결과가 없습니다.</NoResult>
        )}

        {totalPages > 1 && (
          <PaginationCommon
            item_count={10}
            current_page={currentPage}
            total_page={totalPages}
            objectChange={objectChange}
            onClick={() => setState({ ...state, rerender: !rerender })}
            viewName="manage"
          />
        )}
      </Body>
      
      {/* 필터 모달 */}
      <BottomModal
        ref={filterModalRef}
        onClick={() => resetButton()}
        onClick2={() => confirmFilterBtn()}
        onClick3={() => closeBtn()}
        modalTitle="검색 필터"
        headerBtn="초기화"
        footerBtn="적용"
        dimClickFun={closeBtn}
        initVisible={initVisible}
      >
        <List pd="0 15px" itemPd="20px 0">
          <SearchStoreFilterItemV2 title={"매장 유형"} filterList={storeFilterList} changeChecked={changeChecked} />
        </List>
      </BottomModal>
      
      {/* 정렬 모달 */}
      <BottomModal modalTitle="정렬" ref={sortModalRef}>
        <List pd="0 15px">
          <SearchSortItem sortData={["최신순", "오래된순", "가나다순"]} onClick={(e) => sortBtn(e)} initIdx={sortIdx} parentSortIdxFunc={childrenSortIdxFunc} />
        </List>
      </BottomModal>
    </>
  );
}

const FixedBox = styled.div`
  z-index: 100;
  position: sticky;
  top: 60px;
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  background: #fff;
`;

const SelectedBox = styled.div`
  overflow: hidden;
  height: 60px;
  padding: 20px 0;
  background: #f4f4f4;
  transition: height 500ms ease-in-out;
  .title-box {
    padding: 0 15px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    &:focus {
      border: none;
      outline: none;
    }
    > p {
      background: url(${Accodion}) no-repeat right center;
    }
  }
  .chip-box {
    max-height: 150px;
    overflow: hidden;
    padding: 0 15px;
    > div {
      margin-right: 10px;
      margin-top: 10px;
    }
  }
  &.active {
    height: auto;
    transition: height 500ms ease-in-out;
    .title-box {
      > p {
        background: url(${AccodionActive}) no-repeat right center;
      }
    }
    .chip-box {
      overflow-y: scroll;
    }
  }
`;

const SimpleStoreList = styled.ul`
  padding: 0 15px;
  > li {
    padding: 14px 0;
    border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
    
    label {
      position: relative;
      ${({ theme }) => theme.flexBox.flexMixin("row", "center", "center")}
      cursor: pointer;
      
      .tag {
        display: inline-block;
        width: 60px;
        height: 24px;
        line-height: 24px;
        border-radius: 12px;
        background-color: #f4f4f4;
        font-size: 14px;
        color: #60677d;
        text-align: center;
        flex-shrink: 0;
      }
      
      .title {
        flex-grow: 1;
        padding-left: 16px;
        ${({ theme }) => theme.textOverflow.singleLine()}
        font-size: 16px;
        font-weight: 700;
        
        svg {
          margin-left: 4px;
          vertical-align: middle;
        }
        
        .userId {
          position: relative;
          top: -1px;
          display: inline-block;
          margin-left: 8px;
          padding-left: 8px;
          border-left: 2px solid ${({ theme }) => theme.color.lineSecondary};
          color: ${({ theme }) => theme.color.quaternary};
          font-size: 14px;
          font-weight: 400;
        }
      }
      
      > svg {
        flex-shrink: 0;
        margin-left: 13px;
      }
      
      input {
        overflow: hidden;
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        border: 0;
        margin: -1px;
        clip: rect(0 0 0 0);
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        -o-appearance: none;
      }
    }
  }
`;

const CountingSection = styled.div`
  .all-check {
    ${({ theme }) => theme.flexBox.flexMixin()}
    padding: 10px 15px;
    border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  }
  label {
    position: relative;
    ${({ theme }) => theme.flexBox.flexMixin("row", "center", "center")}
    svg {
      margin-left: 8px;
    }
    input {
      overflow: hidden;
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      border: 0;
      margin: -1px;
      clip: rect(0 0 0 0);
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      -ms-appearance: none;
      -o-appearance: none;
    }
  }
`;

const FilterBtnSet = styled.div`
  overflow: hidden;
  overflow-x: scroll;
  width: 100%;
  padding: 15px;
  border-top: 1px solid ${({ theme }) => theme.color.linePrimary};
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start")}
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  > * {
    flex: 0 0 auto;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
  > button {
    > svg {
      position: relative;
      top: -1px;
    }
  }
  .only-new {
    > svg {
      top: 2px;
      left: 2px;
    }
  }
`;

const NoResult = styled.li`
  margin: 80px 0 40px;
  text-align: center;
`;

export default groupAdd;
